"use client"

import { useEffect } from "react"

/**
 * Registers public/sw.js (#210) — production builds only. Renders nothing;
 * mounted once near the app root (src/app/layout.tsx) so it applies across
 * marketing/legal/dashboard routes alike (the app shell + auth-config caching
 * benefit every entry point, not just the authenticated dashboard).
 *
 * Why production-only, not "everything except NODE_ENV==='development'": the
 * e2e harness (#203) also runs `next build` (NODE_ENV=production) with
 * NEXT_PUBLIC_AUTH_TEST_MODE=1 baked in, and mock-api.ts now installs its
 * interceptor at the browser-CONTEXT level (not just the page) specifically so
 * a real, active service worker's own fetches are still caught and mocked —
 * see e2e/support/mock-api.ts. That lets the offline journey in
 * e2e/pwa.spec.ts exercise the real SW instead of a stand-in.
 */
export function ServiceWorkerRegister() {
  useEffect(() => {
    if (typeof window === "undefined") return
    if (!("serviceWorker" in navigator)) return
    if (process.env.NODE_ENV !== "production") return

    navigator.serviceWorker
      .register("/sw.js")
      .catch((err) => console.error("[SW] registration failed", err))
  }, [])

  return null
}
